export default {
  HOME: "/",
  RESTAURANT: (id) => `/discover/:city/${id}`,
  DISCOVER: (city) => `/discover/${city}`,
  CONTACT: "/contact",
  MANIFESTO: "/manifesto",
}
